import React, { useState } from 'react';
import { Modal } from 'react-bootstrap-5';
import ErrorAlert from './error_alert';

export default function JobTitleModal({ closeModal, id, label, submitForm, error }: JobTitleModalProps) {
  const [jobTitleLabel, setJobTitleLabel] = useState(label || '');

  const submit = (e) => {
    e.preventDefault();
    submitForm({ id, label: jobTitleLabel });
  };

  const canSubmitForm = jobTitleLabel !== '';
  const isNew = id === undefined;

  return (
    <form onSubmit={submit}>
      <Modal.Header closeButton>
        <Modal.Title>
          {isNew ? 'Add a' : 'Edit'} Job Title
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ErrorAlert error={error}/>
        <div>
          <label className="form-label mb-1" htmlFor="job-title-label">Job Title</label>
          <input
            autoFocus
            className="form-control"
            id="job-title-label"
            placeholder="Enter job title"
            value={jobTitleLabel}
            onChange={e => setJobTitleLabel(e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-ghost" type="button" onClick={closeModal}>Cancel</button>
        <button className="btn btn-primary" disabled={!canSubmitForm} type="submit">
          {isNew ? 'Add' : 'Update'} Job Title
        </button>
      </Modal.Footer>
    </form>
  );
}

type JobTitleModalProps = {
  closeModal: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  error: string,
  id?: number,
  label?: string,
  submitForm: (jobTitle: { id?: number, label: string }) => void
};
